import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as settings from "../../../constants/settings";
import * as navigationActions from "../../../actions/navigationActions";
import * as settingsActions from "../../../actions/settingsActions";
import * as validationHelper from "../../../helpers/validationHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import imgConfirm from "../../../resources/img/svgicons/confirm.svg";

import CancelButton from "../generic/CancelButton";
import Button, {BUTTON_VARIANT_LINK} from "../generic/Button";
import Input from "../generic/Input";
import Modal from "../generic/Modal";

class PrintTaskModal extends Component {
    constructor(props) {
        super(props);

        if (props.params === undefined || props.params.printTask === undefined || props.params.printTask === null) {
            this.state = {
                index: null,
                name: "",
                printer: settings.OPTION_NONE,
                template: settings.OPTION_NONE,
                action: settings.PRINT_TASK_ACTION_ALL,
                copies: "1",
                preview: false,
                variable: null
            };
        } else {
            this.state = {
                index: props.params.printTask.index,
                name: props.params.printTask.name === null ? "" : props.params.printTask.name,
                printer:
                    props.params.printTask.printer === null ? settings.OPTION_NONE : props.params.printTask.printer,
                template:
                    props.params.printTask.template === null ? settings.OPTION_NONE : props.params.printTask.template,
                action: props.params.printTask.action,
                copies: String(props.params.printTask.copies),
                preview: props.params.printTask.preview,
                variable: this.getValidVariable(props.params.printTask.variable)
            };
        }
    }

    isValid = () => {
        return !(this.state.copies === "" || Number(this.state.copies) < 0);
    };

    getValidVariable = (variable) => {
        if (variable === null) {
            return null;
        }

        if (typeof variable === "string") {
            if (variable.trim().length === 0) {
                return null;
            }

            return [variable.trim()];
        }

        if (!Array.isArray(variable)) {
            return null;
        }

        let validVariable = [];

        for (let item of variable) {
            if (typeof item === "string" && item.trim().length > 0) {
                validVariable.push(item);
            }
        }

        if (validVariable.length === 0) {
            return null;
        }

        return validVariable;
    };

    addPrintTask = () => {
        let newPrintTaskList = this.props.printTaskList.map((task, newIndex) => task.format(newIndex + 1));

        if (this.props.params.type === "after") {
            this.props.dispatchSetPrintTasksAfterDispensingAction([
                ...newPrintTaskList,
                {
                    index: newPrintTaskList.length + 1,
                    name: this.state.name === "" ? null : this.state.name,
                    printer: this.state.printer === settings.OPTION_NONE ? null : this.state.printer,
                    template: this.state.template === settings.OPTION_NONE ? null : this.state.template,
                    action: this.state.action,
                    copies: Number(this.state.copies),
                    preview: this.state.preview,
                    variable: this.getValidVariable(this.state.variable)
                }
            ]);
        }

        if (this.props.params.type === "before") {
            this.props.dispatchSetPrintTasksBeforeDispensingAction([
                ...newPrintTaskList,
                {
                    index: newPrintTaskList.length + 1,
                    name: this.state.name === "" ? null : this.state.name,
                    printer: this.state.printer === settings.OPTION_NONE ? null : this.state.printer,
                    template: this.state.template === settings.OPTION_NONE ? null : this.state.template,
                    action: this.state.action,
                    copies: Number(this.state.copies),
                    preview: this.state.preview,
                    variable: this.getValidVariable(this.state.variable)
                }
            ]);
        }
    };

    editPrintTask = () => {
        let newPrintTaskList = this.props.printTaskList.map((task, newIndex) => {
            if (this.state.index === newIndex + 1) {
                return {
                    index: this.state.index,
                    name: this.state.name === "" ? null : this.state.name,
                    printer: this.state.printer === settings.OPTION_NONE ? null : this.state.printer,
                    template: this.state.template === settings.OPTION_NONE ? null : this.state.template,
                    action: this.state.action,
                    copies: Number(this.state.copies),
                    preview: this.state.preview,
                    variable: this.getValidVariable(this.state.variable)
                };
            }

            return task.format(newIndex + 1);
        });

        if (this.props.params.type === "after") {
            this.props.dispatchSetPrintTasksAfterDispensingAction(newPrintTaskList);
        }

        if (this.props.params.type === "before") {
            this.props.dispatchSetPrintTasksBeforeDispensingAction(newPrintTaskList);
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleNameChange = (event) => {
        this.setState({
            name: event.target.value
        });
    };

    handleTemplateChange = (event) => {
        this.setState({
            template: event.target.value
        });
    };

    handlePrinterChange = (event) => {
        this.setState({
            printer: event.target.value
        });
    };

    handleActionChange = (event) => {
        this.setState({
            action: event.target.value
        });
    };

    handleCopiesChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({
                copies: event.target.value
            });
        }
    };

    handlePreviewChange = () => {
        this.setState({
            preview: !this.state.preview
        });
    };

    handleVariableChange = (event) => {
        let variableIndex = Number(event.target.dataset.index);

        if (Array.isArray(this.state.variable) && this.state.variable[variableIndex] !== undefined) {
            this.setState({
                variable: this.state.variable.map((item, index) => {
                    if (index === variableIndex) {
                        return event.target.value;
                    }

                    return item;
                })
            });
        }
    };

    handleVariableClick = () => {
        if (this.state.variable === null) {
            this.setState({variable: [""]});

            return true;
        }

        if (this.state.variable.length < 3) {
            this.setState({variable: this.state.variable.concat([""])});

            return true;
        }

        return false;
    };

    handleConfirmClick = () => {
        if (this.state.index === null) {
            this.addPrintTask();
        } else {
            this.editPrintTask();
        }

        this.props.dispatchCloseModalAction();
    };

    getTemplateSelectBox = () => {
        if (this.props.templateList.length === 0) {
            return <Translate value="print.noTemplatesAvailable" />;
        }

        return (
            <select className="primary-select col-8" value={this.state.template} onChange={this.handleTemplateChange}>
                <option key={settings.OPTION_NONE} value={settings.OPTION_NONE}>
                    {" - "}
                </option>
                {this.props.templateList.map((template) => (
                    <option key={template.name} value={template.name}>
                        {template.name}
                    </option>
                ))}
            </select>
        );
    };

    getPrinterSelectBox = () => {
        if (this.props.printerList.length === 0) {
            return <Translate value="print.noPrintersAvailable" />;
        }

        return (
            <select className="primary-select col-8" value={this.state.printer} onChange={this.handlePrinterChange}>
                <option key={settings.OPTION_NONE} value={settings.OPTION_NONE}>
                    {" - "}
                </option>
                {this.props.printerList.map((printer) => (
                    <option key={printer.name} value={printer.name}>
                        {printer.name}
                    </option>
                ))}
            </select>
        );
    };

    getVariables = () => {
        return this.state.variable?.map((item, index) => (
            <Input
                key={index}
                className="primary-input col-12"
                elementProps={{"data-index": index}}
                value={item}
                onChange={this.handleVariableChange}
            />
        ));
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-4">
                    <Translate value="general.nameTitle" />:
                </div>
                <Input className="primary-input col-8" value={this.state.name} onChange={this.handleNameChange} />
                <div className="col-4">
                    <Translate value="print.chooseTemplate" />:
                </div>
                {this.getTemplateSelectBox()}
                <div className="col-4">
                    <Translate value="print.choosePrinter" />:
                </div>
                {this.getPrinterSelectBox()}
                <div className="col-4">
                    <Translate value="machineSettings.action" />:
                </div>
                <select className="primary-select col-8" value={this.state.action} onChange={this.handleActionChange}>
                    <option key={settings.PRINT_TASK_ACTION_ALL} value={settings.PRINT_TASK_ACTION_ALL}>
                        {translate("general.all")}
                    </option>
                    <option key={settings.PRINT_TASK_ACTION_STANDARD} value={settings.PRINT_TASK_ACTION_STANDARD}>
                        {translate("general.dispensing")}
                    </option>
                    <option key={settings.PRINT_TASK_ACTION_QUICK_TINT} value={settings.PRINT_TASK_ACTION_QUICK_TINT}>
                        {translate("general.quickTint")}
                    </option>
                </select>
                <div className="col-4">
                    <Translate value="print.copies" />:
                </div>
                <Input className="primary-input col-8" value={this.state.copies} onChange={this.handleCopiesChange} />
                <div className="col-12">
                    <Translate value="print.printVariable" />:
                </div>
                {this.getVariables()}
                {(!this.state.variable || this.state.variable?.length < 3) && (
                    <div className="col-12">
                        <Button
                            variant={BUTTON_VARIANT_LINK}
                            className="color-primary"
                            onClick={this.handleVariableClick}
                            tooltipText={translate("help.environment.printTaskVariable")}
                            label={
                                <React.Fragment>
                                    +<Translate value="print.printTaskLinkVariable" />
                                </React.Fragment>
                            }
                        />
                    </div>
                )}
                <div className="col-4">
                    <Translate value="colorantsTable.preview" />:
                </div>
                <div className="col-8">
                    <input
                        type="checkbox"
                        name="show"
                        id="show"
                        checked={this.state.preview}
                        onChange={this.handlePreviewChange}
                    />
                    <label htmlFor="show">
                        &emsp;
                        <Translate className="ellipsis" value="print.showPreviewDialogBeforePrint" />
                    </label>
                </div>
            </React.Fragment>,
            "flex-wrap flex-row-gap-10px"
        );
    };

    getConfirmButton = () => {
        return (
            <Button
                onClick={this.handleConfirmClick}
                svgBefore={imgConfirm}
                label={<Translate value="general.confirm" />}
                disabled={!this.isValid()}
            />
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="general.printTask" />)}
                content={this.getContent()}
                footer={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.getConfirmButton()}
                        <CancelButton onClick={this.handleCloseModalClick} />
                    </React.Fragment>,
                    "flex-gap-10px"
                )}
                styles={{
                    width: "40%"
                }}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.params !== undefined && ownProps.params.type === "after") {
        return {
            printerList: store.rcc.printerList,
            templateList: store.rcc.templateList,
            printTaskList: store.settings.printTasksAfterDispensing
        };
    }

    return {
        printerList: store.rcc.printerList,
        templateList: store.rcc.templateList,
        printTaskList: store.settings.printTasksBeforeDispensing
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.PRINT_TASK_MODAL));
        },
        dispatchSetPrintTasksAfterDispensingAction: (printTasks) => {
            dispatch(settingsActions.setPrintTasksAfterDispensing(printTasks));
        },
        dispatchSetPrintTasksBeforeDispensingAction: (printTasks) => {
            dispatch(settingsActions.setPrintTasksBeforeDispensing(printTasks));
        }
    };
};

export default PrintTaskModal = connect(mapStoreToProps, mapDispatchToProps)(PrintTaskModal);
